import React from 'react';
import "./Filterpart.css";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Form from 'react-bootstrap/Form';
import { useState } from 'react';
import FilterSidebar from "../Components/FilterSidebar";

export default function FilterPart({ 
  productCount = 0,
  categories = [],
  selectedCategories = [],
  setSelectedCategories,
  maxPrice = 20000,
  setMaxPrice,
  sortBy = "",
  setSortBy
}) {
  const [open, setOpen] = useState(false);
  return (
    <div className="filter_main">
      <div className="container-fluid">
        <div className="row g-2">
           <div className="col-lg-4 col-md-4 col-sm-6 col-6">
           <button className="filter_btn"  onClick={() => setOpen(!open)}>
            <FilterAltOutlinedIcon />
            Filters By
           </button>
           </div>

            <FilterSidebar 
              open={open} 
              setOpen={setOpen} 
              categories={categories}
              selectedCategories={selectedCategories}
              setSelectedCategories={setSelectedCategories}
              maxPrice={maxPrice}
              setMaxPrice={setMaxPrice}
            />
            
           <div className="col-lg-4 col-md-4 col-sm-12 col-12 d-lg-block d-md-block d-none">
            <div className="filter_product_title">
              <h2 className='text-center'>{productCount} PRODUCT{productCount !== 1 ? 'S' : ''}</h2>
            </div>
           </div>

           <div className="col-lg-4 col-md-4 col-sm-6 col-6 d-flex justify-content-end">
             <Form.Select 
               aria-label="Sort products"
               value={sortBy}
               onChange={(e) => setSortBy(e.target.value)}
             >
            <option value=""> SORT BY</option>
            <option value="new_arrival"> Newest</option>
            <option value="popularity"> Popular</option>
            <option value="price_high_to_low">  Price : High to Low</option>
            <option value="price_low_to_high">  Price : Low to High</option>
          </Form.Select>
           </div>
        </div>
        </div>
    </div>
  )
}
